import en from "../locale/en";


export default (text, ...args) => {
  if (text === undefined) return // TO DO: Remove once sure that locale is being called with valid text

  let translatedPhrases = en
  const translation =
    typeof translatedPhrases[text] === 'function' ? translatedPhrases[text](args) : translatedPhrases[text]
  if (translation !== undefined && translation !== null) return translation

  const arr = text.split('.')

  if (arr.length === 0) {
    return text.toString()
  } else if (arr && arr.length === 1) {
    const translatedValue = translatedPhrases[text]
    return translatedValue ? translatedValue.toString() : text.toString()
  } else if (arr.length > 1) {
    arr.map((object) => {
      if (translatedPhrases) {
        translatedPhrases = translatedPhrases[object]
      }
      return;
    })
  }
  return translatedPhrases ? translatedPhrases.toString() : text
}


// WEBPACK FOOTER //
// ./src/utils/locale.js